<div class="ion-page" [class.unauth-page-fill]="fillContentSlot">
  @if (showHeader !== false) {
    <ion-header>
      <ion-toolbar [color]="computedToolbarColor">
        @if (defaultHref) {
          <ion-buttons slot="start">
            <crowdctrl-back-button
              [defaultHref]="defaultHref"
              [backButtonIcon]="backButtonIcon"
            ></crowdctrl-back-button>
          </ion-buttons>
        }
        <ion-title>{{ pageTitle }}</ion-title>
        <ion-buttons slot="end">
          <ng-content select="[slot=header-buttons]"></ng-content>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
  } @else if (showBrandHeader) {
    <ion-header class="ion-no-border unauth-brand-ion-header" [translucent]="true">
      <ion-toolbar class="unauth-brand-toolbar">
        <ng-content select=".unauth-brand-header"></ng-content>
      </ion-toolbar>
    </ion-header>
  }

  @if (fillContentSlot) {
    <ion-content [class]="ionContentClass" [scrollY]="contentScrollY">
      @if (showPwaPullRefresher) {
        <ion-refresher slot="fixed" (ionRefresh)="onPwaPullRefresh($event)">
          <ion-refresher-content
            pullingText="Pull to check for updates"
          ></ion-refresher-content>
        </ion-refresher>
      }
      <div class="page-slot page-slot--fill">
        <ng-content></ng-content>
      </div>
    </ion-content>
  } @else {
    <ion-content [class]="ionContentClass" [scrollY]="contentScrollY">
      @if (showPwaPullRefresher) {
        <ion-refresher slot="fixed" (ionRefresh)="onPwaPullRefresh($event)">
          <ion-refresher-content
            pullingText="Pull to check for updates"
          ></ion-refresher-content>
        </ion-refresher>
      }
      <!-- Match crowdctrl-page: single scroll child wrapper so layout/flex matches authenticated shell -->
      <div class="page-slot" [class.page-slot--login]="isLoginPageContentSlot">
        @if (stickyFooterOutsideScroll) {
          <ng-content select=".unauth-main"></ng-content>
        } @else {
          <ng-content></ng-content>
        }
      </div>
    </ion-content>
  }

  @if (shouldShowFooter) {
    <ion-footer>
      <ion-toolbar class="footer-toolbar">
        <ion-title class="version-text">{{ footerText }}</ion-title>
      </ion-toolbar>
    </ion-footer>
  }
  @if (stickyFooterOutsideScroll) {
    <ion-footer class="unauth-page-footer-unscrollable">
      <ng-content select=".unauth-sticky-footer"></ng-content>
    </ion-footer>
  }
</div>
